import { render, staticRenderFns } from "./SubjectManage.vue?vue&type=template&id=2ce87e52&scoped=true"
import script from "./SubjectManage.vue?vue&type=script&lang=js"
export * from "./SubjectManage.vue?vue&type=script&lang=js"
import style0 from "./SubjectManage.vue?vue&type=style&index=0&id=2ce87e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce87e52",
  null
  
)

export default component.exports